import { useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "reactstrap";
import axios from "axios";
import { PulseLoader } from "react-spinners";
import "../../assets/css/style.css";
import Header from "../Header/Home";
import { APILA } from "../../config/apila";
import { APIMS } from "../../config/apims";
import selfIcon from "../../assets/angket/selfIcon.png";
import peerIcon from "../../assets/angket/peerIcon.png";
import startSelf from "../../assets/angket/startSelf.png";
import startPeer from "../../assets/angket/startPeer.png";

export default function Home() {
  const navigate = useNavigate();
  document.title = "Assessment Platform";

  // const API_BASE = "https://api.la.sims.alazharsummarecon.sch.id";

  const studentProfile = useMemo(() => {
    try {
      return JSON.parse(localStorage.getItem("student_profile") || "{}");
    } catch {
      return {};
    }
  }, []);

  // token: fleksibel supaya gak merusak project kalau key beda
  const token = useMemo(() => {
    return (
      localStorage.getItem("token") ||
      localStorage.getItem("access_token") ||
      localStorage.getItem("student_token") ||
      ""
    );
  }, []);

  // ====== HEADER AXIOS ======
  const axiosHeaders = useMemo(() => {
    return {
      "Content-Type": "application/json",
      Accept: "application/json",
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
    };
  }, [token]);

  const student = useMemo(() => {
    return {
      name: studentProfile?.nama_siswa || "-",
      studentId: localStorage.getItem("nisn") || "-",
      ysb_student_id:
        studentProfile?.ysb_student_id ||
        localStorage.getItem("ysb_student_id") ||
        "-",
      ysb_branch_id:
        studentProfile?.ysb_branch_id || localStorage.getItem("ysb_branch_id") || "-",
      ysb_school_id:
        studentProfile?.ysb_school_id || localStorage.getItem("ysb_school_id") || "-",
      ysb_grade_level_id:
        studentProfile?.ysb_grade_level_id ||
        localStorage.getItem("ysb_grade_level_id") ||
        "-",
      ysb_kelas_id:
        studentProfile?.ysb_kelas_id || localStorage.getItem("ysb_kelas_id") || "-",
      ysb_kelas_name:
        studentProfile?.ysb_kelas_name || localStorage.getItem("ysb_kelas_name") || "-",
      ysb_grade_level_name:
        studentProfile?.ysb_grade_level_name ||
        localStorage.getItem("ysb_grade_level_name") ||
        "-",
      ysb_semester_id:
        studentProfile?.ysb_semester_id || localStorage.getItem("ysb_semester_id") || "-",
    };
  }, [studentProfile]);

  const [loadingDashboard, setLoadingDashboard] = useState(true);
  const [dashboard, setDashboard] = useState(null);
  const [activeSemesterId, setActiveSemesterId] = useState("");

  // const fetchDashboard = async () => {
  //   setLoadingDashboard(true);
  //   try {
  //     const payload = {
  //       ysb_branch_id: student.ysb_branch_id,
  //       ysb_school_id: student.ysb_school_id,
  //       ysb_semester_id: student.ysb_semester_id,
  //       ysb_student_id: student.ysb_student_id,
  //       ysb_grade_level_id: student.ysb_grade_level_id,
  //     };

  //     const res = await APILA.get("/api/dashboard", {
  //       headers: axiosHeaders,
  //       params: payload, // GET via params
  //     });

  //     setDashboard(res?.data?.data || null);
  //   } catch (err) {
  //     console.error("Gagal load dashboard:", err);
  //     setDashboard(null);
  //   } finally {
  //     setLoadingDashboard(false);
  //   }
  // };

  const fetchActiveSemester = async () => {
  try {
    const res = await APIMS.get("/api/access/semesters", {
      headers: axiosHeaders,
      params: {
        page: 1,
        limit: 100,
        ascending: 0,
      },
    });

    const semesters = res?.data?.data || [];

    const activeSemester = semesters.find(
      (item) => Number(item?.status) === 1
    );

    if (activeSemester?.id) {
      setActiveSemesterId(activeSemester.id);

      // simpan juga ke localStorage agar halaman formAngket tetap ikut semester aktif
      localStorage.setItem("ysb_semester_id", activeSemester.id);

      return activeSemester.id;
    }

    return student.ysb_semester_id;
  } catch (err) {
    console.error("Gagal load semester aktif:", err);

    // fallback supaya fitur lama tetap aman
    return student.ysb_semester_id;
  }
};

const fetchDashboard = async () => {
  setLoadingDashboard(true);

  try {
    const semesterIdAktif = await fetchActiveSemester();

    const payload = {
      ysb_branch_id: student.ysb_branch_id,
      ysb_school_id: student.ysb_school_id,
      ysb_semester_id: semesterIdAktif,
      ysb_student_id: student.ysb_student_id,
      ysb_grade_level_id: student.ysb_grade_level_id,
    };

    const res = await APILA.get("/api/dashboard", {
      headers: axiosHeaders,
      params: payload,
    });

    setDashboard(res?.data?.data || null);
  } catch (err) {
    console.error("Gagal load dashboard:", err);
    setDashboard(null);
  } finally {
    setLoadingDashboard(false);
  }
};

  // useEffect(() => {
  //   fetchDashboard();
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [
  //   student.ysb_branch_id,
  //   student.ysb_school_id,
  //   student.ysb_semester_id,
  //   student.ysb_student_id,
  //   student.ysb_grade_level_id,
  // ]);

  useEffect(() => {
  fetchDashboard();
  // eslint-disable-next-line react-hooks/exhaustive-deps
}, [
  student.ysb_branch_id,
  student.ysb_school_id,
  student.ysb_semester_id,
  student.ysb_student_id,
  student.ysb_grade_level_id,
]);

  const safeSelf = dashboard?.penilaian_diri || {};
  const safePeer = dashboard?.penilaian_rekan || {};
  const studentInfo = dashboard?.student_info || {};

  const statusToBadgeStyle = (statusText) => {
    const s = String(statusText || "").toLowerCase();
    if (s.includes("selesai")) return { background: "#DCFCE7", color: "#16A34A" };
    if (s.includes("proses")) return { background: "#FEF3C7", color: "#D97706" };
    return { background: "#FEE2E2", color: "#DC2626" };
  };

  const cards = {
    self: {
      title: "Menilai Diri",
      subtitle: "Evaluasi Diri Sendiri",
      status: safeSelf?.status || "Belum",
      total: Number(safeSelf?.total_questions || 0) || 0,
      answered: Number(safeSelf?.answered || 0) || 0,
      textProgress: "Presentase Penyelesaian",
      percentage: `${safeSelf.progress_percentage}`,
    },
    peer: {
      title: "Menilai Rekan",
      subtitle: "Evaluasi Rekan",
      status: safePeer?.status || "Belum",
      total: Number(safePeer?.total_questions || 0) || 0,
      answered: Number(safePeer?.answered || 0) || 0,
      textProgress: "Presentase Penyelesaian",
      percentage: `${safePeer.progress_percentage}`,
    },
  };

  const isDoneStatus = (status) => {
    const s = String(status ?? "").toLowerCase();
    return s.includes("selesai") || Number(status) === 3;
  };

  const isSelfDone = isDoneStatus(cards?.self?.status || safeSelf?.status);
  const isPeerDone = isDoneStatus(cards?.peer?.status || safePeer?.status);

  const assignedPeer = {
    name: safePeer?.nama_siswa || "-",
  };

  // ✅ ini yang diminta: ysb_student_id dari penilaian_rekan untuk peer
  const peerDinilaiId = safePeer?.ysb_student_id || "";

  // const goToAssessment = (type = "self") => {
  //   if (type === "peer") {
  //     // kirim ke formAngket sebagai siswa_dinilai_id
  //     const qs = new URLSearchParams();
  //     qs.set("type", "peer");
  //     if (peerDinilaiId) qs.set("siswa_dinilai_id", peerDinilaiId);

  //     // simpan juga sebagai fallback (tidak mengganggu fitur yang ada)
  //     if (peerDinilaiId) localStorage.setItem("siswa_dinilai_id", peerDinilaiId);

  //     navigate(`/assessment-form?${qs.toString()}`);
  //     return;
  //   }

  //   navigate(`/assessment-form?type=self`);
  // };

  const goToAssessment = (type = "self") => {
  const semesterIdAktif =
    activeSemesterId ||
    localStorage.getItem("ysb_semester_id") ||
    student.ysb_semester_id ||
    "";

  if (semesterIdAktif) {
    localStorage.setItem("ysb_semester_id", semesterIdAktif);
  }

  if (type === "peer") {
    const qs = new URLSearchParams();
    qs.set("type", "peer");

    if (semesterIdAktif) qs.set("ysb_semester_id", semesterIdAktif);
    if (peerDinilaiId) qs.set("siswa_dinilai_id", peerDinilaiId);

    if (peerDinilaiId) localStorage.setItem("siswa_dinilai_id", peerDinilaiId);

    navigate(`/assessment-form?${qs.toString()}`);
    return;
  }

  const qs = new URLSearchParams();
  qs.set("type", "self");
  if (semesterIdAktif) qs.set("ysb_semester_id", semesterIdAktif);

  navigate(`/assessment-form?${qs.toString()}`);
};

  const handleLogout = () => {
    localStorage.removeItem("student_logged_in");
    localStorage.removeItem("student_profile");
    localStorage.removeItem("token_expiry");
    localStorage.removeItem("ysb_student_id");
    localStorage.removeItem("nama_siswa");
    localStorage.removeItem("ysb_semester_id");
    localStorage.removeItem("ysb_branch_id");
    localStorage.removeItem("ysb_school_id");
    localStorage.removeItem("ysb_grade_level_id");
    localStorage.removeItem("ysb_kelas_id");
    localStorage.removeItem("ysb_kelas_name");
    localStorage.removeItem("ysb_grade_level_name");
    localStorage.removeItem("ysb_teacher_id");
    localStorage.removeItem("ysb_teacher_id2");
    localStorage.removeItem("nisn");
    localStorage.removeItem("token");
    localStorage.removeItem("access_token");
    localStorage.removeItem("student_token");
    localStorage.removeItem("siswa_dinilai_id");

    navigate("/");
  };

  return (
    <div style={styles.page}>
      <Header />
      <style>{`
        /* === RESPONSIVE DASHBOARD SISWA (HP) === */
        @media (max-width: 576px) {
          /* Info NISN / Sekolah / Kelas -> per baris */
          .studentBadgeWrapMobile {
            flex-direction: column !important;
            align-items: stretch !important;
            gap: 10px !important;
          }
          .studentBadgeWrapMobile .studentBadgeItem {
            width: 100% !important;
            display: block !important;
          }

          /* Tombol "Mulai Penilaian" -> pindah ke bawah nama */
          .peerRowMobile {
            flex-direction: column !important;
            align-items: stretch !important;
          }
          .peerRowMobile .peerLeftMobile {
            width: 100% !important;
          }
          .peerRowMobile .startBtnMobile {
            width: 100% !important;
          }
        }
      `}</style>

      <main style={styles.container}>
        {loadingDashboard ? (
          <div style={styles.loadingWrap}>
            <PulseLoader size={10} color="#3b60e8" />
          </div>
        ) : (
          <>
            <section style={{ marginBottom: 18 }}>
              <h1 style={styles.welcomeTitle}>
                Assalamualaikum, {studentInfo?.nama_siswa || student.name}!
              </h1>

              <div style={styles.studentBadgeWrap} className="studentBadgeWrapMobile">
                <span style={styles.studentBadge} className="studentBadgeItem">
                  NISN: {studentInfo?.nisn || student.studentId}
                </span>
                <span style={styles.studentBadge} className="studentBadgeItem">
                  Sekolah: {studentInfo?.ysb_school_id || student.ysb_school_id}
                </span>
                <span style={styles.studentBadge} className="studentBadgeItem">
                  Kelas: {student.ysb_grade_level_name} - {student.ysb_kelas_name}
                </span>
              </div>
            </section>

             {/* <span style={styles.studentBadge} className="studentBadgeItem">
  Semester ID: {activeSemesterId || student.ysb_semester_id}
</span> */}

            <section style={styles.gridTopCards}>
              {/* CARD SELF */}
              <div style={{ ...styles.card }} role="button" tabIndex={0}>
                <div style={styles.cardHeader}>
                  <div>
                    <img style={{ width: 62 }} src={selfIcon} alt="self" />
                  </div>
                  <div>
                    <span style={{ ...styles.badge, ...statusToBadgeStyle(cards.self.status) }}>
                      {cards.self.status}
                    </span>
                  </div>
                </div>

                <h3 style={styles.cardTitle}>{cards.self.title}</h3>

                <div style={{ display: "flex", alignItems: "center" }}>
                  <div style={{ ...styles.iconPillProgress, background: "#DCFCE7", color: "#16A34A" }}>
                    📈
                  </div>
                  <span style={styles.cardSubtitle}>
                    {cards.self.textProgress} • {cards.self.percentage}
                  </span>
                </div>

                <div style={styles.progressTrack}>
                  <div style={{ ...styles.progressFill, width: `${cards.self.percentage}` }} />
                </div>

                <div style={styles.remainingText}>
                  Terjawab: <b>{cards.self.answered}</b> / {cards.self.total}
                </div>
              </div>

              {/* CARD PEER */}
              <div style={{ ...styles.card }} role="button" tabIndex={0}>
                <div style={styles.cardHeader}>
                  <div>
                    <img style={{ width: 65 }} src={peerIcon} alt="peer" />
                  </div>
                  <div>
                    <span style={{ ...styles.badge, ...statusToBadgeStyle(cards.peer.status) }}>
                      {cards.peer.status}
                    </span>
                  </div>
                </div>

                <h3 style={styles.cardTitle}>{cards.peer.title}</h3>

                <div style={{ display: "flex", alignItems: "center" }}>
                  <div style={{ ...styles.iconPillProgress, background: "#DCFCE7", color: "#16A34A" }}>
                    📈
                  </div>
                  <span style={styles.cardSubtitle}>
                    {cards.peer.textProgress} • {cards.peer.percentage}
                  </span>
                </div>

                <div style={styles.progressTrack}>
                  <div style={{ ...styles.progressFill, width: `${cards.peer.percentage}` }} />
                </div>

                <div style={styles.remainingText}>
                  Terjawab: <b>{cards.peer.answered}</b> / {cards.peer.total}
                </div>
              </div>
            </section>

            <section style={styles.card}>
              <h3 style={styles.sectionTitle}>Menilai Diri</h3>

              <div style={styles.peerRow} className="peerRowMobile mb-4">
                <div style={styles.peerLeft} className="peerLeftMobile">
                  <img
                    style={{ ...styles.iconPill, background: "#EEF2FF", color: "#6366F1" }}
                    src={startSelf}
                    alt="start self"
                  />
                  <div>
                    <div style={styles.peerName}>{studentInfo?.nama_siswa || student.name}</div>
                    <div style={styles.peerGrade}>
                      Kelas: {student.ysb_grade_level_name} - {student.ysb_kelas_name}
                    </div>
                  </div>
                </div>

                <Button
                  color="primary"
                  className="startBtnMobile"
                  style={{ ...styles.startBtn, ...(isSelfDone ? styles.startBtnDisabled : {}) }}
                  onClick={() => goToAssessment("self")}
                  disabled={isSelfDone}
                >
                  Mulai Penilaian
                </Button>
              </div>

              <h3 style={styles.sectionTitle}>Menilai Rekan</h3>

              <div style={styles.peerRow} className="peerRowMobile">
                <div style={styles.peerLeft} className="peerLeftMobile">
                  <img
                    style={{ ...styles.iconPill, background: "#EEF2FF", color: "#6366F1" }}
                    src={startPeer}
                    alt="start peer"
                  />
                  <div>
                    <div style={styles.peerName}>{assignedPeer.name}</div>
                    <div style={styles.peerGrade}>
                      Kelas: {student.ysb_grade_level_name} - {student.ysb_kelas_name}
                    </div>
                    {/* opsional debug kecil (aman) */}
                    {/* <div style={{ fontSize: 11, color: "#9CA3AF" }}>ID Dinilai: {peerDinilaiId || "-"}</div> */}
                  </div>
                </div>

                <Button
                  color="primary"
                  className="startBtnMobile"
                  style={{
                    ...styles.startBtn,
                    ...((isPeerDone || !peerDinilaiId) ? styles.startBtnDisabled : {}),
                  }}
                  onClick={() => goToAssessment("peer")}
                  disabled={isPeerDone || !peerDinilaiId}
                  title={!peerDinilaiId ? "ID siswa yang dinilai belum tersedia" : undefined}
                >
                  Mulai Penilaian
                </Button>
              </div>
            </section>
          </>
        )}
      </main>
    </div>
  );
}

const styles = {
  page: {
    minHeight: "100vh",
    background: "#F8FAFC",
    color: "#111827",
    fontFamily:
      'Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif',
  },
  container: { maxWidth: 1220, margin: "0 auto", padding: "22px 18px 28px" },
  welcomeTitle: { margin: 0, fontSize: 28, fontWeight: 800, lineHeight: 1.1 },
  gridTopCards: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))",
    gap: 16,
    marginBottom: 16,
  },
  card: {
    background: "#FFFFFF",
    border: "1px solid #E5E7EB",
    borderRadius: 14,
    padding: 18,
    boxShadow: "0 1px 2px rgba(0,0,0,0.03)",
  },
  cardHeader: { display: "flex", justifyContent: "space-between", marginBottom: 14 },
  iconPill: {
    width: 38,
    height: 38,
    borderRadius: 10,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: 16,
    fontWeight: 700,
  },
  iconPillProgress: {
    width: 30,
    height: 30,
    borderRadius: 10,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: 16,
    fontWeight: 700,
  },
  loadingWrap: { minHeight: "60vh", display: "flex", alignItems: "center", justifyContent: "center" },
  badge: { fontSize: 12, fontWeight: 700, padding: "5px 10px", borderRadius: 999 },
  studentBadgeWrap: { marginTop: 10, display: "flex", gap: 8, flexWrap: "wrap" },
  studentBadge: {
    background: "#eeeef7",
    color: "#325ae9",
    border: "1px solid #c5d4f1",
    borderRadius: 999,
    fontWeight: 700,
    fontSize: 12,
    padding: "5px 10px",
  },
  cardTitle: { margin: "0 0 6px", fontSize: 22, fontWeight: 800 },
  cardSubtitle: {
    margin: "10px 5px",
    fontSize: 14,
    color: "#6B7280",
    fontWeight: 500,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  progressTrack: {
    width: "100%",
    height: 10,
    background: "#E5E7EB",
    borderRadius: 999,
    overflow: "hidden",
    marginTop: 8,
  },
  progressFill: { height: "100%", background: "#22C55E", borderRadius: 999, transition: "width .25s ease" },
  remainingText: { margin: "8px 0 0", fontSize: 13, color: "#6B7280", fontWeight: 500 },
  sectionTitle: { margin: "0 0 14px", fontSize: 22, fontWeight: 800, color: "#3b60e8" },
  peerRow: {
    background: "#F8FAFC",
    border: "1px solid #E5E7EB",
    borderRadius: 12,
    padding: 12,
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: 12,
  },
  peerLeft: { display: "flex", alignItems: "center", gap: 10 },
  peerName: { fontSize: 16, fontWeight: 700 },
  peerGrade: { fontSize: 13, color: "#6B7280" },
  startBtn: { borderRadius: 10, padding: "10px 16px", fontWeight: 700, whiteSpace: "nowrap" },
  startBtnDisabled: { opacity: 0.6, cursor: "not-allowed" },
  logoutBtn: { border: "none", background: "transparent", color: "#DC2626", fontWeight: 700, cursor: "pointer" },
};